import React, { useEffect, useState } from 'react'
import axios from 'axios'
import { Status } from '@svort/component'

const InitAction = (props) => {

    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(undefined);

    useEffect(() => {
        const getToken = async () => {
            const response = await axios.get('/init_action');
            // const response = await axios.get('https://localhost:4006/init_action');

            const { status, token, message } = response?.data;

            if (status === 'success') {
                props.history.push(props.location.state?.route, { token });
            } else {
                console.error(message);
                setError('init_error');
            }

            setLoading(false);
        };

        setTimeout(() => {
            getToken();
        }, 1000);
    }, [props.history, props.location.state, props.route]);

    return (
        <Status
            isShow={loading || !!error}
            isLoading={loading}
            isError={!!error}
            onRetry={() => window.location.reload()}>
            {error || 'init_action'}
        </Status>
    )
}

export default InitAction
